// A stale boundary only refreshes state. The player chooses whether to try the action again.
import { reloadRefusedEncounter } from './truth-refusal-notice';
const COOLDOWN_MS = 1000;
const recoveries = new Map<string, { until: number; promise: Promise<void> }>();

export function resyncStaleCombatBoundary(encounterId: string, operationId?: string): Promise<void> {
  const id = encounterId.trim().toUpperCase(), now = Date.now();
  for (const [key, state] of recoveries) if (state.until <= now) recoveries.delete(key);
  const held = recoveries.get(id);
  if (held) return held.promise;
  const state = { until: Infinity, promise: Promise.resolve() };
  state.promise = Promise.resolve().then(() => reloadRefusedEncounter(id, operationId))
    .catch(error => { console.error('Failed to recover stale combat state:', id, error); })
    .finally(() => { state.until = Date.now() + COOLDOWN_MS; });
  recoveries.set(id, state);
  return state.promise;
}
